import { SerializedData } from 'bernie-core';
import { AnalyticsStore } from 'bernie-plugin-mobx';
import { SystemEvent, SystemEventLevel } from 'bernie-logger';
import { RequestOptions } from 'bernie-graphql';

import { FlightsFlexibleDiscoverySearch } from '__generated__/api/';
import analyticsWrapper from 'utility/analytics-wrapper';
import { clientInfoHeader } from 'utility/header-utils';
import { BaseBexApiStore } from './bex-api-store';

export class FlexibleSearchStore extends BaseBexApiStore {
  public hydrate(data: SerializedData): void {
    super.hydrate(data);

    this.bexApiSource.clientConfigs.bexApiUrl = '/graphql';
  }

  public fetchResults(
    searchVariables: FlightsFlexibleDiscoverySearch.Variables,
    options: RequestOptions,
    analytics: AnalyticsStore
  ): Promise<FlightsFlexibleDiscoverySearch.FlexibleSearch> {
    const { appName, region } = this.bexApiSource.clientConfigs;
    this.bexApiSource.headers = clientInfoHeader(this.bexApiSource.headers, appName, region);

    return this.bexApiSource.operations
      .flightsFlexibleDiscoverySearch(searchVariables, options)
      .then(response => {
        const { flexibleSearch } = response.data;

        analyticsWrapper.setFlexibleSearchAnalytics(response);
        analyticsWrapper.publishSearchAnalyticsPayload(analytics);

        return {
          ...flexibleSearch
        };
      })
      .catch(error => {
        this.logger.logEvent(new SystemEvent(SystemEventLevel.WARN, 'FLEX_DISCOVERY_SEARCH_FETCH'), error);

        return null;
      });
  }
}
